<template>
<section class="Section NoTopPadding">
			<div class="Container">
				<div class="BoxWide">
					<div class="BookingPanel">
						<booking-navigator></booking-navigator>						
						<div class="BookingContent">
							<div class="BookingResumeTable">
								<div>
									<table width="100%" border="0" cellspacing="0" cellpadding="1">
										<tbody>
											<tr>
												<th scope="col">Nome del Centro</th>
												<th scope="col">Data della visita</th>
												<th scope="col">Orario</th>
											</tr>
											<tr>
												<td>
													<div class="ResumeTableLabel">Nome del Centro</div>
													<div class="ResumeTableAddress">
														<h4>{{  descrizione  }}</h4>														
														<p>{{ indirizzo }}</p>
													</div>
												</td>
												<td>
													<div class="ResumeTableLabel">Data della visita</div>
													<p>{{ giornoCompleto }}</p>
												</td>
												<td>
													<div class="ResumeTableLabel">Orario</div>
													<p>{{ orarioCompleto }}</p>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
							<div class="BookingForm">
								<div>
									<div class="Wrapper">
										<div class="Widget">
											<div class="Form">
												<div class="FormRow">
													<div class="FormBoxWide">
														<div class="FormClaim">Compila il form e invia la tua prenotazione</div>
													</div>
												</div>
												<div class="FormRow">
													<div class="FormBox50">
														<div class="Label">Nome *</div>														
                                                        <input type="text" class="Field form-input" id="nome" v-model="nome" />
													</div>
													<div class="FormBox50">
														<div class="Label">Cognome *</div>
                                                        <input type="text" class="Field form-input" id="cognome" v-model="cognome" />														
													</div>
												</div>
												<div class="FormRow">
													<div class="FormBox50">
														<div class="Label">Email *</div>
                                                        <input type="text" class="Field form-input" id="email" v-model="email" />
														
													</div>
													<div class="FormBox50">
														<div class="Label">Numero di telefono *</div>
                                                        <input type="text" class="Field form-input" id="telefono" v-model="telefono" />														
													</div>
												</div>
												<div class="FormRow">
													<div class="FormBoxWide FormCheckBox">
														<div class="Label">Accetto le <a href="/">condizioni di vendita</a></div>
														<!-- <div class="Field"></div>  -->
                                                        <input type="checkbox" id="checkCondVendita" class="Field" v-model="chkCondVendita" />                                                       
													</div>
												</div>
												<div class="FormRow">
													<div class="FormBoxWide FormCheckBox">
														<div class="Label">Ho preso visione dell’informativa sul trattamento dei miei dati personali ai sensi del <a href="#">regolamento (UE) n. 2016/679 *</a></div>
														<!-- <div class="Field"></div> -->
														<input type="checkbox" id="checkCondVendita" class="Field" v-model="chkDatiPersonali" />
													</div>
												</div>
												<div class="FormRow">
													<div class="FormBoxWide FormInputButton">
														<div class="Field">
															<div class="Button TwinButton">
																<router-link :to="{'name': 'BookingPanelMap'}">Annulla</router-link>
																<a v-if="!this.isLoading" href="javascript:void(0)" @click="prenotaOra()">Prenota Ora</a>
																<a v-else href="javascript:void(0)" class="disabled" >Prenota Ora</a>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div class="Form">
												<div class="Alert Good" v-show="showSuccess">
													<div class="AlertTitle">Il tuo appuntamento è stato inoltrato correttamente</div>
													<div class="AlertText">Abreve riceverai una e-mail di conferma.</div>
												</div>
												<div class="Alert Bad" v-show="showError">
													<div class="AlertTitle">Ops! Qualcosa è andato storto</div>
													<div class="AlertText">Qualcosa nella trasmissione dell'ordine è andato storto. Ti preghiamo di riprovare.</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<!-- <div class="Button TwinButton Checkout"><a href="/">Annulla</a> <a href="#">Prenota Ora</a></div> -->
						</div>
					</div>
				</div>
			</div>
		</section>
		<DxToast
			v-model:visible="isToastVisible"                                        
			v-model:message="msgErrore"
			type="error"
			:height="60"
			:width="500"
			:displayTime= "3000"
			position="center"							
		>                                    
		</DxToast>
</template>

<script>

import BookingNavigator from '@/components/BookingNavigator.vue';
import { DxToast } from 'devextreme-vue/toast';
import WebApiService from "@/services/webapi.service.js";

export default{

    name: "BookingForm",
    data(){
		return {
			nome: "",
			cognome: "",
			email: "",
			telefono: "",
			chkCondVendita: false,
			chkDatiPersonali: false,
			isToastVisible: false,
			msgErrore: "",
			showSuccess: false,
			showError: false,
			isLoading: false
		}
    },
	computed: {
		descrizione(){
			return this.$store.getters.getCentro?.Descrizione;
		},
		indirizzo(){
			return this.$store.getters.getCentro?.Indirizzo;
		},
        giornoCompleto(){
            return this.$store.getters.getGiornoCompleto;
        },
        orarioCompleto(){
            return this.$store.getters.getOrarioCompleto;
        },
	},
    methods:{
		prenotaOra(){

			let listErrorFields = []
			if(!this.nome){
				listErrorFields.push("Nome");
			}
			if(!this.cognome){
				listErrorFields.push("Cognome");
			}
			if(!this.email){
				listErrorFields.push("Email");
			}
			if(!this.telefono){
				listErrorFields.push("Telefono");
			}
			if(!this.chkCondVendita){
				listErrorFields.push("Condizioni di vendita");
			}
			if(!this.chkDatiPersonali){
				listErrorFields.push("Dati personali")
			}

			if(listErrorFields.length > 0){
				this.msgErrore = "Attenzione! Impossibile inviare la richiesta. I seguenti campi sono obbligatori: " + listErrorFields.join(",");
				this.isToastVisible = true;
				return;
			}
			
			let body = {
				Email: this.email,
				IdCentro: this.$store.getters.getCentro.IdCentro,
				Nome: this.nome,
				Cognome: this.cognome,
				Telefono: this.telefono,
				DataPrenotazione: this.$store.getters.getGiorno,
				OraPrenotazione: this.$store.getters.getOrario
			};
			this.isLoading = true;
			WebApiService.post('Prenotazione/InsertPrenotazione', "", body, {}).then(
				(data) => { 	
					this.isLoading = false;
					if(data.StatusCode !== 200){
						this.msgErrore = "Attenzione si è verificato un errore interno al sistema: " + data.Message;
						this.isToastVisible = true;
					}
					else{	
						
						this.showSuccess = true;
					}
				},
				error => {
					console.log(error);	
					this.msgErrore = "Attenzione si è verificato un errore interno al sistema!";
					this.isToastVisible = true;		
				}
				)
				.catch(              
					error => {
						console.log(error);		
						this.msgErrore = "Attenzione si è verificato un errore interno al sistema!";
						this.isToastVisible = true;					
					}				
				);
		}
    },
    components:{
        BookingNavigator,
		DxToast
    }    
}
</script>

<style scoped>

.Button.TwinButton >*:nth-of-type(2) {
    background-color: #dd6464;
    border-color: #dd6464;
    float: right;
}

.form-input{
    width: calc(100% - 40px);
}

.container-checkbox{
	display: block;
	position: relative;
	padding-left: 35px;
	margin-bottom: 12px;
	cursor: pointer;
	font-size: 22px;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

.disabled{
	background-color: #d7d7d7;
}

.container-checkbox input{
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 16px;
  width: 16px;
  background-color: #fff;
  border: 2px solid #d7d7d7;
}

/* On mouse-over, add a grey background color */
.container-checkbox:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.container-checkbox input:checked ~ .checkmark {
  background-color: #fff;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container-checkbox input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container-checkbox .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}


</style>